export default "__VITE_ASSET__BSIGHfUh__"